import { render, staticRenderFns } from "./SharedMediaUpdate.vue?vue&type=template&id=56228359&"
import script from "./SharedMediaUpdate.vue?vue&type=script&lang=js&"
export * from "./SharedMediaUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports